import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { MessageService } from 'primeng/api';
import { catchError, map, Observable, throwError } from 'rxjs';

import { ServiceResponseV1 } from '@core/models/apis';
import { OrdersConfigurationV1, UpdateOrdersConfigurationRequestV1 } from '@orders/configuration/orders-configuration';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersConfigurationService {
  private readonly http = inject(HttpClient);
  private readonly messageService = inject(MessageService);
  private readonly httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  private readonly apiUrl = `${environment.apiUrl}${environment.apis.ordersEngineAdmin}/v1/config`;

  createOrdersConfigurationResource() {
    return rxResource<OrdersConfigurationV1 | null, void>({
      stream: () =>
        this.http.get<ServiceResponseV1<OrdersConfigurationV1>>(this.apiUrl).pipe(
          map((response) => response.data ?? null),
          catchError((err) => this.errorHandler(err))
        )
    });
  }

  updateOrdersConfiguration(request: UpdateOrdersConfigurationRequestV1): Observable<OrdersConfigurationV1 | null> {
    return this.http.put<ServiceResponseV1<OrdersConfigurationV1>>(this.apiUrl, request, this.httpOptions).pipe(
      map((response) => response.data ?? null),
      catchError((err) => this.errorHandler(err))
    );
  }

  private errorHandler(err: unknown): Observable<never> {
    const error =
      err instanceof HttpErrorResponse
        ? new Error(`HTTP ${err.status}: ${err.message}`)
        : err instanceof Error
          ? err
          : new Error(String(err));
    console.error('[OrdersConfigurationService]', error);
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to load or save orders configuration'
    });
    return throwError(() => error);
  }
}
